import { createContext, useState, useCallback, type ReactNode } from 'react';

export interface Notification {
  id: number;
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
}

export interface NotificationContextValue {
  notifications: Notification[];
  add: (notification: Notification) => void;
  remove: (id: number) => void;
}

const NotificationContext = createContext<NotificationContextValue>({
  notifications: [],
  add: () => {},
  remove: () => {},
});

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const add = useCallback((notification: Notification) => {
    setNotifications((prev) => [...prev, notification]);
  }, []);

  const remove = useCallback((id: number) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ notifications, add, remove }}>
      {children}
    </NotificationContext.Provider>
  );
}

export default NotificationContext;
